var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialMediaF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#4987FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1897 14.8066H31.258V9.87109H28.1897C26.3832 9.87327 24.6512 10.5919 23.3737 11.8693C22.0963 13.1468 21.3777 14.8788 21.3755 16.6854V19.7421H18.0967V24.6775H21.387V41.0272H26.3225V24.6775H29.6474L30.6213 19.7421H26.3225V15.7789C26.3263 15.5219 26.4302 15.2766 26.6121 15.095C26.794 14.9135 27.0395 14.81 27.2964 14.8066H28.1897Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaF);
export default __webpack_public_path__ + "static/media/SocialMedia_f.f3d8459dfcd5f66518a6aa96284eade7.svg";
export { ForwardRef as ReactComponent };